import { render, staticRenderFns } from "./view-select-resource.vue?vue&type=template&id=6aca3c4c"
import script from "./view-select-resource.vue?vue&type=script&lang=js"
export * from "./view-select-resource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports